import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs/Observable';
import {HeaderService} from './header.service';

@Injectable()
export class AutomatModelService extends HeaderService{


    getAutomatModelsByBrand(automatBrand: string): Observable<any> {
        /*eslint-disable */
        return this.http.get(environment.apiBaseUrl
            + 'automat-models-by-brand/' + automatBrand  , this.httpBearerOptions)
            .map((res: Response) => {
                return res;
            })
            // ...errors if any
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
        /*eslint-enable */
    }
    getAutomatModel(automatModel: any): Observable<any> {
        console.log(automatModel._id);
        /*eslint-disable */
        return this.http.get(environment.apiBaseUrl
            + 'automat-model/' + automatModel._id  , this.httpBearerOptions)
            .map((res: Response) => {
                return res;
            })
            // ...errors if any
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
        /*eslint-enable */
    }

    searchModels(page: number, automatBrand: string, name: string): Observable<any> {
        /*eslint-disable */
        return this.http.post(environment.apiBaseUrl + 'search-automat-models/' + page,
            JSON.stringify({  automatBrand: automatBrand, name: name }),
            this.httpBearerOptions)
            .map((res: Response) => {
                return res;
            })
            // ...errors if any
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
        /*eslint-enable */
    }

    createModel(model: any): Observable<any> {
        return this.http.post(environment.apiBaseUrl + 'automat-model',
            JSON.stringify(model),
            this.httpBearerOptions)
            .map((res: Response) => {
                return res;
            })
            // ...errors if any
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    updateModel(model: any, id: string): Observable<any> {
        return this.http.put(environment.apiBaseUrl + 'automat-model/' + id,
            JSON.stringify(model),
            this.httpBearerOptions)
            .map((res: Response) => {
                return res;
            })
            // ...errors if any
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    deleteModel(_id: string): Observable<any> {
        /*eslint-disable */
        return this.http.delete(environment.apiBaseUrl + 'automat-model/' + _id,
            this.httpBearerOptions)
            .map((res: Response) => {
                return res;
            })
            // ...errors if any
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
        /*eslint-enable */
    }

}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/services/automat-model.service.ts